// ============================================================
// mockVideoAssets.js — placeholder music for the Video Editor (v1)
// ------------------------------------------------------------
// Source clips now come from the client's real uploaded library (see
// ClipBrowser + /api/video/upload-clip). The music catalogue is still mock
// here and will come from the Jamendo integration later.
//
// Each track ships with a pre-baked `peaks` array (0..1) so the waveform
// renders deterministically without decoding any real audio.
// ============================================================

// ── Deterministic pseudo-waveform generator ──────────────────────────────────
// Builds `count` peaks in the 0.15..1 range from a seeded sine mix so each
// mock track has a stable, distinct-looking waveform.
function buildPeaks(seed, count = 64) {
  const peaks = [];
  for (let i = 0; i < count; i++) {
    const a = Math.sin((i + seed) * 0.35) * 0.5 + 0.5;
    const b = Math.sin((i + seed) * 0.11 + seed) * 0.5 + 0.5;
    const env = 0.35 + 0.65 * Math.sin((i / count) * Math.PI); // fade in/out envelope
    const v = (a * 0.6 + b * 0.4) * env;
    peaks.push(Math.max(0.15, Math.min(1, v)));
  }
  return peaks;
}

// ── Mock music catalogue (Jamendo comes later) ───────────────────────────────
// `url` is null for now — the picker is selection-only in v1. When Jamendo is
// wired up these become real stream URLs and the shape stays identical.
export const MOCK_TRACKS = [
  {
    id: 'track-mock-1',
    title: 'Sunlit Mornings',
    artist: 'Autopilot Library',
    mood: 'Upbeat',
    bpm: 112,
    duration: 142,
    url: null,
    peaks: buildPeaks(3),
  },
  {
    id: 'track-mock-2',
    title: 'City Lights',
    artist: 'Autopilot Library',
    mood: 'Energetic',
    bpm: 128,
    duration: 168,
    url: null,
    peaks: buildPeaks(11),
  },
  {
    id: 'track-mock-3',
    title: 'Slow Drift',
    artist: 'Autopilot Library',
    mood: 'Chill',
    bpm: 90,
    duration: 195,
    url: null,
    peaks: buildPeaks(21),
  },
  {
    id: 'track-mock-4',
    title: 'Bold Statement',
    artist: 'Autopilot Library',
    mood: 'Cinematic',
    bpm: 100,
    duration: 154,
    url: null,
    peaks: buildPeaks(37),
  },
];

export const TRACK_MOODS = ['All', ...Array.from(new Set(MOCK_TRACKS.map((t) => t.mood)))];

// Format seconds → m:ss
export function fmtTime(secs) {
  if (secs == null || Number.isNaN(secs)) return '0:00';
  const s = Math.max(0, Math.floor(secs));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${String(r).padStart(2, '0')}`;
}
